import { render, staticRenderFns } from "./view-question.vue?vue&type=template&id=212da6f5&scoped=true"
import script from "./view-question.vue?vue&type=script&lang=js"
export * from "./view-question.vue?vue&type=script&lang=js"
import style0 from "./view-question.vue?vue&type=style&index=0&id=212da6f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212da6f5",
  null
  
)

export default component.exports